import {
  getFirestore,
  collection,
  query as fsQuery,
  where,
  getDocs,
  limit,
} from 'firebase/firestore';

const db = getFirestore();

/**
 * Removes bold/italic/strike/link for the next typed characters (empty selection),
 * or strips those marks from the current non-empty selection.
 * TipTap's unsetAllMarks() is a no-op when the selection is empty — stored marks
 * would still apply to new text; unsetMark per type clears stored marks.
 */
export function clearFormatting(editor) {
  if (!editor?.isEditable) return;
  const { empty } = editor.state.selection;
  if (!empty) {
    editor.chain().focus().unsetAllMarks().unsetLink().run();
  } else {
    editor
      .chain()
      .focus()
      .unsetMark('bold')
      .unsetMark('italic')
      .unsetMark('strike')
      .unsetLink()
      .run();
  }
}

export async function queryUsers(queryStr) {
  if (!queryStr) return [];
  const q = fsQuery(
    collection(db, 'users'),
    where('handle', '>=', queryStr.toLowerCase()),
    where('handle', '<', queryStr.toLowerCase() + '\uf8ff'),
    limit(6)
  );
  const snap = await getDocs(q);
  return snap.docs
    .map((d) => ({ uid: d.id, ...d.data() }))
    .filter((u) => u.handle);
}

export function getMentionedHandles(editor) {
  return (
    editor
      .getJSON()
      .content?.flatMap((node) => node.content ?? [])
      .filter((node) => node.type === 'mention')
      .map((node) => node.attrs.id) ?? []
  );
}

export function normalizeLinkHref(raw) {
  const t = raw.trim();
  if (!t) return '';
  return /^https?:\/\//i.test(t) ? t : `https://${t}`;
}

export function linkApplyAllowed(editor, selectionEmpty, linkText, linkUrl) {
  const url = linkUrl.trim();
  const text = linkText.trim();
  if (selectionEmpty) {
    return Boolean(text && url);
  }
  if (url) return true;
  return editor.isActive('link');
}
